import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function WhoIsFor() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const forWho = ['Mujeres que enfrentan "infertilidad de causa desconocida".', 'Parejas que han pasado por tratamientos fallidos y buscan una respuesta emocional y espiritual.', 'Personas que sienten que repiten patrones de pérdida o dificultad de sus madres o abuelas.', 'Mujeres que desean preparar su interior antes de un nuevo intento de fertilización asistida.'];
  const notFor = ['Personas que buscan una solución mágica sin intención de mirar su historia familiar.', 'Quienes esperan que este libro reemplace el diagnóstico de un médico especialista.', 'Personas que no creen en la conexión entre las emociones y el cuerpo.'];
  return <section ref={ref} className="w-full bg-gradient-to-b from-white to-cream py-10 md:py-16 px-6" data-id="element-141">
      <div className="max-w-6xl mx-auto" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-143">
          <div className="grid md:grid-cols-2 gap-6" data-id="element-144">
            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-rose/10" data-id="element-145">
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-brown mb-6 text-center" data-id="element-146">
                Para Quién Es Este Método
              </h2>
              <div className="space-y-3" data-id="element-147">
                {forWho.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {}} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="flex gap-3 items-start" data-id="element-148">
                    <CheckCircleIcon className="w-6 h-6 text-rose flex-shrink-0 mt-0.5" data-id="element-149" />
                    <p className="font-sans text-base text-brown/90 leading-relaxed" data-id="element-150">
                      {item}
                    </p>
                  </motion.div>)}
              </div>
            </div>

            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-brown/10" data-id="element-151">
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-brown mb-6 text-center" data-id="element-152">
                Para Quién NO Es
              </h2>
              <div className="space-y-3" data-id="element-153">
                {notFor.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: 20
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {}} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="flex gap-3 items-start" data-id="element-154">
                    <XCircleIcon className="w-6 h-6 text-brown/40 flex-shrink-0 mt-0.5" data-id="element-155" />
                    <p className="font-sans text-base text-brown/70 leading-relaxed" data-id="element-156">
                      {item}
                    </p>
                  </motion.div>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}